var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 12.5c0 1.934-1.566 3.5-3.5 3.5a3.499 3.499 0 01-3.5-3.5c0-1.934 1.566-3.5 3.5-3.5s3.5 1.566 3.5 3.5zm-1.75 0c0-.962-.788-1.75-1.75-1.75-.963 0-1.75.788-1.75 1.75 0 .963.787 1.75 1.75 1.75.962 0 1.75-.787 1.75-1.75zM16 16.875c-2.336 0-7 1.172-7 3.5v1.75c0 .481.394.875.875.875h12.25a.878.878 0 00.875-.875v-1.75c0-2.328-4.664-3.5-7-3.5zm-5.25 3.509v.866h10.5v-.875c-.175-.621-2.887-1.75-5.25-1.75s-5.075 1.129-5.25 1.759z",
    fill: "#8CABCA"
  })));
}
export default SvgUserinline;